import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService } from './auth.service';
import { HeaderService } from '../../common/services/header.service';
import { CommonService } from '../../common/services/common.service';
import { ModuleSecurityService } from '../../settings/services/module-security-service';
import { ApiResponse, ModulePermissions } from '../../common/models/common.model';

/**
 * Guard which is used to deny unauthorized access.
 */
export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(AuthService);
  const headerService = inject(HeaderService);
  const commonService = inject(CommonService);
  const moduleSecurityService = inject(ModuleSecurityService);
  const router = inject(Router);

  // Check whether the current user is authenticated or not
  if (authService.isAuthenticated()) {
    // Get the token of the current user.
    const token: string = authService.getToken();
    if (token) {
      // Set the request headers with authentication details.
      headerService.setHeaders('default', 'Authorization', token);
    }
    try {
      return moduleSecurityService.getUserRolePermissions().pipe(
        map((res: ApiResponse<ModulePermissions>) => {
          if (res.success && res.data && !res.data.user.customer.isOrganisationSetup) {
            router.navigate(['/organisation-setup']);
          }
          return true;
        })
      );
    } catch (e) {
      return false;
    }
  } else {
    const encryptedParam: string = commonService.setParam(JSON.stringify(route.params));
    router.navigate(['/signin'], { queryParams: { returnUrl: state.url, paramData: encryptedParam } });
    return false;
  }
};
